
import { defineComponent } from 'vue';
import WidgetBase from './WidgetBase.vue';

export default defineComponent({
    components: {
        WidgetBase,
    },
    setup() {
        return {};
    },
});
